import { useMutation } from '@tanstack/react-query'
import { useAPI } from '../../../Contexts/APIContext'

export const useChangeOrganizationUsersRole = () => {
  const { changeOrganizationUsersRole } = useAPI()

  return useMutation({
    mutationFn: data =>
      changeOrganizationUsersRole({
        ...data,
      }),
  })
}
